import FormFieldLabel from 'src/components/atoms/FormFieldLabel/FormFieldLabel'

export default FormFieldLabel
